module.exports = __webpack_public_path__ + "img/default-chess-queen.cc2d3dfd.svg";